import { createSelector } from 'reselect'
import getInsuranceItemsView from './getInsuranceItemsView'

const getLoyaltyInsuranceBenefitItemViews = createSelector(
  (state: App.State) => getInsuranceItemsView(state),
  (insuranceItems) => {
    return insuranceItems.data.filter(insuranceData => insuranceData.loyalty.savingsAmount! > 0)
  },
)

export default getLoyaltyInsuranceBenefitItemViews
